
export default {
    // 默认页的数据
    pageList:[
        {
            title:'统计分析',
            type:'1',
            url:require('../../../assets/images/tj.jpg'),
            text:'分布统计可实现性别、年龄、就诊日期、就诊次数、症状、舌质、舌苔、脉象、四诊综合、中医疾病、西医疾病、中医证候、治法、方剂、中药、穴位、疗效对总频次、频次、百分比的统计。统计结果将以饼状图、折线图、柱状图、表格的形式进行展示并且下载。'
        },
        {
            title:'聚类分析',
            type:'2',
            url:require('../../../assets/images/jl.jpg'),
            text:'给定要聚类的N的对象以及N*N的距离矩阵(或者是相似性矩阵), 层次式聚类方法的基本步骤(参看S.C. Johnson in 1967) 如下: 1将每个对象归为一类, 共得到N类, 每类仅包含一个对象.类与类之间的距离就是它们所包含的对象之间的距离. 2找到最接近的两个类并合并成一类,于是总的类数少了一个. 3重新计算新的类与所有旧类之间的距离. 4重复第2步和第3步, 直到最后合并成一个类为止(此类包含了N个对象)。'
        },
        {
            title:'K-Means聚类',
            type:'3',
            url:require('../../../assets/images/km.jpg'),
            text:'k均值聚类算法（k-means clustering algorithm）是一种迭代求解的聚类分析算法，其步骤是，预将数据分为K组，则随机选取K个对象作为初始的聚类中心，然后计算每个对象与各个种子聚类中心之间的距离，把每个对象分配给距离它最近的聚类中心。聚类中心以及分配给它们的对象就代表一个聚类。每分配一个样本，聚类的聚类中心会根据聚类中现有的对象被重新计算。这个过程将不断重复直到满足某个终止条件。终止条件可以是没有（或最小数目）对象被重新分配给不同的聚类，没有（或最小数目）聚类中心再发生变化，误差平方和局部最小。'
        },
        // {
        //     title:'社团分析',
        //     type:'4',
        //     url:require('../../../assets/images/st.jpg'),
        //     text:'许多实际网络都具有一个共同性质，即社团结构。也就是说，整个网络是由若干个“群”或“团”构成的。每个群内部的节点之间的连接相对非常紧密，但是各个群之间的连接相对来说却比较稀疏。算法过程位计算所有连接边的最短路径，删除边介最大数的链接边；重新计算所有连接边的最短路径；重复步骤2直到网络被划分为两个部分；迭代上述过程，直到没有可划分的链接边的存在。'
        // },
        {
            title:'关联分析',
            type:'5',
            url:require('../../../assets/images/gl.jpg'),
            text:'关联分析又称关联挖掘，就是在交易数据、关系数据或其他信息载体中，查找存在于项目集合或对象集合之间的频繁模式、关联、相关性或因果结构。或者说，关联分析是发现数据库中不同项之间的联系。'
        },
        {
            title:'复杂网络分析',
            type:'6',
            url:require('../../../assets/images/fzwl.jpg'),
            text:' 复杂网络将复杂系统内各部件抽象为节点，部件之间的关系抽象为边，就构成了一个具有复杂连接关系的网络，这种抽象过滤了系统纷繁复杂的背景信息，只保留了系统的基本结构，有助于对系统内在的性质和特征进行研究。'
        },
        {
            title:'网络药理学',
            type:'',
            url:require('../../../assets/images/wlylx.jpg'),
            text:'网络药理学包含最全面的中药，蛋白质-蛋白质相互作用和疾病目标数据库，包括49615种配方，9355种草药，47411种成分，6813种药物和6364种疾病。通过网络药理分析，可以通过推断常规医学的明确研究来阐明中药的药理机理。基于该数据库，研究人员不仅可以进行网络药理分析以阐明中药配方食品的潜在治疗机制，还可以通过上传配方食品或相应靶标中的草药来研究自行设计药物的可能药理机制。'
        }
    ],
    // 统计分析
    statisticsList:[
        {
            value:'基本统计',
            list:[
                {
                    value:'年龄统计',
                    type:'age',
                },
                {
                    value:'性别统计',
                    type:'sex',
                },
                {
                    value:'就诊日期',
                    type:'consultation',
                },
                {
                    value:'诊次统计',
                    type:'diagnosis',
                }
            ]
        },
        {
            value:'四诊统计',
            list:[
                {
                    value:'症状统计',
                    type:'clinicalFeature',
                },
                {
                    value:'舌质统计',
                    type:'tongueNature',
                },
                {
                    value:'舌苔统计',
                    type:'tongueCoating',
                },
                {
                    value:'脉象统计',
                    type:'pulseCondition',
                },
                {
                    value:'四诊综合',
                    type:'fourDiagnoses',
                }
            ]
        },
        {
            value:'病证统计',
            list:[
                {
                    value:'中医疾病统计',
                    type:'tcmDisease',
                },
                {
                    value:'西医疾病统计',
                    type:'wcmDisease',
                },
                {
                    value:'中医证候统计',
                    type:'tcmSyndrome',
                },
                {
                    value:'证素统计',
                    type:'layerType',//有弹层
                    change:[
                        {
                            value:'病位',
                            type:'location'
                        },
                        {
                            value:'病性',
                            type:'nature'
                        }
                    ]
                },
                {
                    value:'治法统计',
                    type:'therapy',
                }
            ]
        },
        {
            value:'诊疗统计',
            list:[
                {
                    value:'方剂统计',
                    type:'prescription',
                },
                {
                    value:'中药统计',
                    type:'formulaComposition',
                },
                {
                    value:'中药属性',
                    type:'layerType',
                    change:[
                        {
                            value:'四气',
                            type:'four'
                        },
                        {
                            value:'五味',
                            type:'five'
                        },
                        {
                            value:'归经',
                            type:'tropism'
                        },
                        {
                            value:'功效',
                            type:'effect'
                        }
                    ]
                },
                {
                    value:'穴位统计',
                    type:'pointSelection',
                },
                {
                    value:'疗效统计',
                    type:'comprehensive',
                }
            ]
        }
    ],
    // 
    echartTab:[
        {
            value:'饼图',
            type:'pie',
            num:1,
        },
        {
            value:'柱状图',
            type:'bar',
            num:2,
        },
        {
            value:'方剂识别',
            type:'recognize',
            num:5,
        },
        {
            value:'雷达图',
            type:'radar',
            num:3,
        },
        {
            value:'生成报告',
            type:'report',
            num:4,
        },
    ],
    radarEchart:{
        // if(val=='four'||val=='five'||val=='tropism'||val=='effect'){
        four:{
            data:['大寒','寒','微寒','凉','平','微温','温','热','大热'],
            value:[0, 67,75,2,74,16,119,9,0],
            startAngle:90
        },
        five:{
            data:['微酸','酸','微苦','苦','淡','微甘','甘','微辛','辛','咸','涩'],
            value: [0, 43, 9, 160, 152, 19, 0, 134, 0, 13, 19,0],
            startAngle:74
        },
        tropism:{
         
            data:["肺", "肝", "胆", "三焦", "心包","肾","膀胱", "小肠", "心", "脾","胃","大肠"],
            value: [135, 99, 29, 5, 3, 76, 14, 76, 89, 217, 158, 16,135],
            startAngle:105
        },
    },
    // 层次聚类的距离类型
    distanceOptins:[
        {
            value:'euclidean',
            label:'欧氏距离'
        },
        {
            value:'maximum',
            label:'切比雪夫距离'
        },
        {
            value:'manhattan',
            label:'绝对值距离'
        },
        {
            value:'canberra',
            label:'Lance距离'
        }
    ],
    //层次聚类的聚类方法
    clusterOptins:[
        {
            value:'complete',
            label:'最长距离法'
        },
        {
            value:'single',
            label:'最短距离法'
        },
        {
            value:'average',
            label:'类平均法'
        },
        {
            value:'centroid',
            label:'重心法'
        }
    ],
    pixelOptins:[
        {
            label:72,
            value:72,
        },
        {
            label:100,
            value:100,
        },
        {
            label:150,
            value:150,
        },
        {
            label:200,
            value:200,
        },
        {
            label:250,
            value:250,
        },
        {
            label:300,
            value:300,
        },
    ],
    // 选项前后数据
    radioOption:[
        {
            value:'临床表现',
            label:'clinicalFeature',
        },
        {
            value:'中医疾病',
            label:'tcmDisease',
        },
        {
            value:'西医疾病',
            label:'wcmDisease',
        },
        {
            value:'中医证候',
            label:'tcmSyndrome',
        },
        {
            value:'治法',
            label:'therapy',
        },
        {
            value:'方剂',
            label:'prescription',
        },
        {
            value:'中药',
            label:'formulaComposition',
        },
        {
            value:'穴位',
            label:'pointSelection',
        },
        {
            value:'疗效',
            label:'comprehensive',
        }
    ],
    // 关联分析的表格
    relevanceList:[
        {
            name:'支持度（Support）',
            explain:'表示同时包含A和B的事务占所有事务的比例。',
            formula:'表示同时包含A和B的事务占所有事务的比例。',
        },
        {
            name:'可信度（Confidence）',
            explain:'表示使用包含A的事务中同时包含B事务的比例，即同时包含A和B的事务占包含A事务的比例。',
            formula:'Confidence=P(A&B)/P(A)',
        },
        {
            name:'提升度（Lift）',
            explain:'表示“包含A的事务中同时包含B事务的比例”与“包含B事务的比例”的比值。 提升度反映了关联规则中的A与B的相关性，提升度>1且越高表明正相关性越高，提升度<1且越低表明负相关性越高，提升度=1表明没有相关性。',
            formula:'Lift=( P(A&B)/P(A))/P(B)=P(A&B)/P(A)/P(B)',
        },
        {
            name:'覆盖率',
            explain:'覆盖率是度量测试完整性的一个手段，是测试有效性的一个度量。',
            formula:'',
        },
        {
            name:'共现度	',
            explain:'数据A 和数据B同时出现的次数。',
            formula:'',
        }
    ],
    // 复杂网络分析的表格
    complexList:[
        {
            typeName:'层次网络算法',
            description:'Hierarchical Networks是对网络进行层次划分之后的展示，可从稀疏的网络中抽取核心的网络，算法需要指定两个参数Layer Number（层数，决定从网络中心到网络外围生成网络图的个数）和DegreeCoefficient（度系数，决定了生成图的密集程度，值越小，留下的结点越多）。',
        },
        {
            typeName:'多尺度的backbone网络算法',
            description:'Multi-scale backbone是一种基于统计模型的显著边发现方法，可从稀疏的网络中抽取核心的网络，通过设定的置信度参数对网络进行⻣干网络抽取，从⽽留下在有权网络中认为是重要的边，同时去掉认为不重要的边。此方法可设置Wconfidence置信度参数。',
        }
    ],
    // 复杂网络分析的类型
    complexOptins:[
        {
            label:'普通关系',
            value:'0001',
        },
        {
            label:'层次网络算法',
            value:'0002',
        },
        {
            label:'多尺度的backbone网络算法',
            value:'0003',
        }
    ],
    // 卡方检验
    checkList:[
        {
            typeName:'卡方检验',
            description:'四格表的χ2检验，主要是用来推断两个总体率或构成比之间有无差别，根本思想就是在于比较理论频数和实际频数的吻合程度或拟合优度。结果对同现频次、p值进行排序。p＜0.05的显示为红色结果，表示两者关系密切。',
        },
    ],
    // 贝叶斯
    bayesList:[
        {
            typeName:'贝叶斯',
            description:`<p class='description-text'>贝叶斯公式当分析样本大到接近总体数时，样本中事件发生的概率将接近于总体中事件发生的概率。其公式为：</p>
                <div class='description-img'><img src="${require('../../../assets/images/bayes-formula.png')}"></div>
                <p class='description-text'>其中，P(B∣A)通过A的参数值判断属于类别B的概率，为后验概率，P（B）体现了总体中的某个样本属于类别B的概率。P(A∣B)为先验概率，体现了类别B中统计到的到事件A的概率,P(A)是在数据集中观测到A的概率。</p>`,
        },
    ],
    // 互信息法
    mutualList:[
        {
            typeName:'点式互信息',
            description:`<p class='description-text'>点式互信息( Pointwise Mutual Information,PMI )是一种广泛用于分析事件相关的方法，具有针对离散随机变量中相对稀疏的数据分布进行分析的特点。可用于分析临床随症、随证、随病加减变化规律。 公式如下：</p>
            <div class='description-img'><img src="${require('../../../assets/images/mutual-formula.png')}"></div>
            <p >（1）p(x,y)表示某中药和某证候同时出现的频度；</p>
            <p >（2）p(x) 表示某药物与所有相关证候的累计同现频度之和，即某药物总的使用概率；
            <p >（3）p(y)是表示某证候与所有相关药物的累计同现频度之和，即某证候出现的总概率。 若中药和证候无相关关系，那么SI(x,y) =0，所以SI(x,y)越大说明该中药与这一症状的相关性越高。</p>`,
        },
    ],
     
    // 层次聚类-聚类分析显示方式
    displayMode:[
        {
            value:'1',
            label:'竖向聚类图'
        },
        {
            value:'2',
            label:'横向聚类图'
        },
        {
            value:'3',
            label:'圆形竖向聚类图'
        },
    ],
    // 关联分析-置信度
    believeList:[
        {
            label:'0',
            value:'0.0',  
        },
        {
            label:'0.1',
            value:'0.1', 
        },
        {
            label:'0.2',
            value:'0.2', 
        },
        {
            label:'0.3',
            value:'0.3', 
        },
        {
            label:'0.4',
            value:'0.4', 
        },
        {
            label:'0.5',
            value:'0.5', 
        },
        {
            label:'0.6',
            value:'0.6', 
        },
        {
            label:'0.7',
            value:'0.7', 
        },
        {
            label:'0.8',
            value:'0.8', 
        },
        {
            label:'0.9',
            value:'0.9', 
        },
        {
            label:'1',
            value:'1.0', 
        },
    ],
    // 关联分析-支持度
    supportList:[
        {
            label:'0.1',
            value:'0.1', 
        },
        {
            label:'0.2',
            value:'0.2', 
        },
        {
            label:'0.3',
            value:'0.3', 
        },
        {
            label:'0.4',
            value:'0.4', 
        },
        {
            label:'0.5',
            value:'0.5', 
        },
        {
            label:'0.6',
            value:'0.6', 
        },
        {
            label:'0.7',
            value:'0.7', 
        },
        {
            label:'0.8',
            value:'0.8', 
        },
        {
            label:'0.9',
            value:'0.9', 
        },
        {
            label:' 1',
            value:' 1', 
        },
    ],
    editionList:[
        {
            label:'有角药',
            value:'2', 
        },
        {
            label:'无角药',
            value:'1', 
        },
    ],
    // 复杂网络-布局
    layoutAll:{
        layoutList:[
            {
                label:'random',
                value:'random',
            },
            {
                label:'mds',
                value:'mds',
            },
            {
                label:'grid',
                value:'grid',
            },
            {
                label:'force',
                value:'force',
            },
            {
                label:'circular',
                value:'circular',
            },
            // {
            //     label:'dagre',
            //     value:'dagre',
            // },
            {
                label:'concentric',
                value:'concentric',
            },
        ],
        // 节点距离
        distanceMarks: {
            1: '1',
            13: '13',
            26: '26',
            38: '38',
            50: '50',
        },
        // 节点大小
        sizeMarks: {
            1: '1',
            25: '25',
            50: '50',
            75:'75',
            100:'100'
        },
        // 字体大小
        fontSizeMarks:{
            1: '1',
            50: '50',
        },
        // 边宽大小
        sideMarks:{
            1: '1',
            3: '3',
            5: '5',
            7:'7',
            10:'10'
        },
        // 节点形状
        shapeList:[
            {
                label:'circle',
            },
            // {
            //     label:'donut',//甜甜圈 
            // },
            {
                label:'ellipse',//椭圆
            },{
                label:'triangle',//三角形
            },{
                label:'rect',//方形
            },{
                label:'diamond',//菱形矩形
            },{
                label:'star',//五角星
            },
        ],
        //边形状
        edgeShapeList:[
            {label:'line'},
            {label:'quadratic'},
            {
                label:'polyline',
            },{
                label:'cubic-vertical',
            },{
                label:'cubic-horizontal',
            },{
                label:'arc',
            },
        ],
        // 边样式
        edgeClassList:[
            {
                label:'solid',
                // path: `G6.Arrow.triangle()`,
            },{
                label:'dashed',
                // path: G6.Arrow.vee(),
            }, {
                label:'dotted',
                // path: G6.Arrow.circle(5, 0),
            }, 
        ]
    }
}